import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UiModule } from 'src/app/ui/ui.module';

@Component({
  selector: 'liv-app-loading-shell',
  imports: [UiModule, TranslatePipe],
  templateUrl: './app-loading-shell.component.html',
  styleUrl: './app-loading-shell.component.scss',
  host: {
    class: 'block h-full'
  }
})
export class AppLoadingShellComponent {
  readonly titleKey = input.required<string>();
  readonly messageKey = input.required<string>();
  readonly currentYear = new Date().getFullYear();
}
